import React, { useState } from 'react';
import SectionColumns from './SectionColumns';
import SectionHeader from './SectionHeader';
import { useAttributeFormBuilder, useFetchedValues, useLayout } from '../../../../Hooks/Display/useComponentProperties';
import { findDraggedColumn, findDraggedColumnSectionId } from '../utils';

const Sections = ({ draggedAttributeId, onDropAttribute }) => {
    const [{ steps }, dispatch] = useAttributeFormBuilder();
    const layout = useLayout();
    const [draggedColumnId, setDraggedColumnId] = useState(null);
    const [fetchedValues] = useFetchedValues();

    // Handle drop for both attributes and columns
    const handleDrop = (columns, dropSectionId) => {
        if (draggedAttributeId) {
            handleDropAttribute(columns, dropSectionId);
        } else if (draggedColumnId) {
            handleDropColumn(columns, dropSectionId);
        }
    };

    // Handle dropping an attribute onto a section
    const handleDropAttribute = (columns, dropSectionId) => {
        const { attributes } = fetchedValues.attributeTable;
        const draggedAttribute = attributes.find(attribute => attribute._id === draggedAttributeId);
        dispatch.addColum(columns, dropSectionId, draggedAttribute);
        onDropAttribute(null);
    };

    // Handle dropping a column within or between sections
    const handleDropColumn = (columns, dropSectionId) => {
        const draggedColumn = findDraggedColumn(layout, draggedColumnId);
        const dragSectionId = findDraggedColumnSectionId(layout, draggedColumn);

        if (dragSectionId === dropSectionId) {
            dispatch.dropColumnInSameSection(columns, dropSectionId, draggedColumn);
        } else {
            dispatch.dropColumnInDifferentSection(columns, dragSectionId, dropSectionId, draggedColumn);
        }
        setDraggedColumnId(null);
    };

    // Render sections
    return layout.map((section, index) => (
        <div key={index} className={section.columns.length === 0 ? 'border section-empty-border mb-4 shadow-sm rounded' : "border mb-4 shadow-sm rounded"}>
            <SectionHeader sectionId={section.id} />
            <SectionColumns
                section={section}
                draggedColumnId={draggedColumnId}
                onDropColumn={handleDrop}
                onDragColumn={setDraggedColumnId}
            />
        </div>
    ));
};

export default Sections;